
export const FETCH_LOOKUP_REQUEST = 'FETCH_LOOKUP_REQUEST';
export const FETCH_LOOKUP_REQUEST_COMPLETED = 'FETCH_LOOKUP_REQUEST_COMPLETED';
export const FETCH_LOOKUP_REQUEST_ERROR = 'FETCH_LOOKUP_REQUEST_ERROR';

export const FETCH_VERSION_LOOKUP_REQUEST = 'FETCH_VERSION_LOOKUP_REQUEST';
export const FETCH_VERSION_LOOKUP_REQUEST_COMPLETED = 'FETCH_VERSION_LOOKUP_REQUEST_COMPLETED';
export const FETCH_VERSION_LOOKUP_REQUEST_ERROR = 'FETCH_VERSION_LOOKUP_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/lookup.js